<template>
  <div class="part3" id="if2021-kv">
    <img
      class="img2 part3_img2"
      src="https://summit-img.geekpark.net/if2021/pc/日程备份.svg"
      :style="{ transform: `translate3d(${moveOnImgPosition1}px,0,0)` }"
    />
    <!-- 28号日程 -->
    <div class="kv18-title-img-wrapper">
      <img
        class="img1 kv-title-img"
        src="https://summit-img.geekpark.net/if2021/pc/1.28-pc-3.svg"
      />
    </div>
    <div class="guest-list-wrapper">
      <guestItem v-for="(item, index) in kv28" :key="index" :guestInfo="item" />
    </div>
    <!-- 29号日程 -->
    <img
      class="img3"
      src="https://summit-img.geekpark.net/if2021/pc/1.29-pc-3.svg"
    />
    <div class="guest-list-wrapper">
      <guestItem v-for="(item, index) in kv29" :key="index" :guestInfo="item" />
    </div>
    <!-- 30号日程-下午 -->
    <img
      class="img4"
      src="https://summit-img.geekpark.net/if2021/pc/1.30-下午-pc-3.svg"
    />
    <div class="guest-list-wrapper">
      <guestItem
        v-for="(item, index) in kv30_1"
        :key="index"
        :guestInfo="item"
      />
    </div>
    <!-- 30号日程-晚上 -->
    <img
      class="img5"
      src="https://summit-img.geekpark.net/if2021/pc/1.30-晚上-pc-3.svg"
    />
    <div class="guest-list-wrapper">
      <guestItem
        v-for="(item, index) in kv30_2"
        :key="index"
        :guestInfo="item"
      />
    </div>
  </div>
</template>

<script>
import guestItem from "./GuestItem";

export default {
  name: "Part3",
  data() {
    return { moveOnImgPosition1: 0, scrollHeight: 0 };
  },
  components: { guestItem },
  computed: {
    kv28() {
      return this.$store.state.guestsList.kv28;
    },
    kv29() {
      return this.$store.state.guestsList.kv29;
    },
    kv30_1() {
      return this.$store.state.guestsList.kv30_1;
    },
    kv30_2() {
      return this.$store.state.guestsList.kv30_2;
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll, false);
  },
  methods: {
    handleScroll() {
      const scrollHeight =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const scrollInstance = scrollHeight - this.scrollHeight;
      this.scrollHeight = scrollHeight;
      const { left, right } = document
        .querySelector("#if2021-kv")
        .getBoundingClientRect();
      if (left <= 400 && right > 1800) {
        this.moveOnImgPosition1 += scrollInstance;
      }
      if (this.scrollHeight === 0) {
        this.moveOnImgPosition1 = 0;
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll, false);
  },
};
</script>

<style lang="less" scoped>
.part3 {
  position: relative;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .kv18-title-img-wrapper {
    padding-left: 16vh;
  }
  .img1 {
    height: 80vh;
    width: auto;
  }
  .img2 {
    height: 43vh;
    width: auto;
    position: absolute;
    top: -10vh;
    left: -39vh;
    z-index: -2;
    transition: transform 0.5s ease-out, -webkit-transform 0.5s ease-out;
  }
  .img3,
  .img4,
  .img5 {
    height: 100vh;
    width: auto;
    margin-left: -90vh;
    position: relative;
    z-index: -1;
    margin-right: 10vh;
  }
  .img3 {
    height: 103vh;
  }
  .img4 {
    height: 94vh;
    margin-left: -60vh;
  }
  .img5 {
    height: 97vh;
    margin-left: -60vh;
  }
  .guest-list-wrapper {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    padding: 10vh 0vh 10vh 0vh;
  }
}
</style>